import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import type { PostConfirmInfosDeliverymanParams } from './types';

const postConfirmInfosDeliveryman = async ({
  deliverymanId,
  data,
}: {
  deliverymanId: string;
  data: Partial<PostConfirmInfosDeliverymanParams>;
}) =>
  apiClient
    .post(`entregadores/${deliverymanId}/v2/approve`, {
      ...data,
    })
    .then(response => {
      handleResponseSuccess(
        response,
        'As informações foram enviadas com sucesso!',
      )();
    })
    .catch(
      handleResponseThrowError(
        'Não foi possível enviar as informações do entregador.',
      ),
    );

export const usePostConfirmInfosDeliveryman = ({
  onSuccess,
}: { onSuccess?: () => void } = {}) => {
  return useMutation({
    mutationFn: postConfirmInfosDeliveryman,
    onSuccess,
  });
};
